'use client'

import { MoonIcon, SunIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useColorMode } from '@/hooks/useColorMode'
import { cn } from '@/lib/utils'

export const ThemeSwitcher = ({ className = '' }: { className?: string }) => {
  const { colorMode, setColorMode } = useColorMode()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'toggleTheme',
  })

  return (
    <div className={cn('flex w-full gap-2', className)}>
      <button
        aria-label={t('label')}
        className={`flex h-7 w-full min-w-8 items-center justify-center rounded border bg-background transition-colors hover:bg-muted ${
          colorMode === 'light' ? 'ring-2 ring-ring' : ''
        }`}
        onClick={() => setColorMode('light')}
        type="button"
      >
        <SunIcon className="size-5" />
      </button>
      <button
        aria-label={t('label')}
        className={`flex h-7 w-full min-w-8 items-center justify-center rounded border bg-background transition-colors hover:bg-muted ${
          colorMode === 'dark' ? 'ring-2 ring-ring' : ''
        }`}
        onClick={() => setColorMode('dark')}
        type="button"
      >
        <MoonIcon className="size-5" />
      </button>
    </div>
  )
}

ThemeSwitcher.displayName = 'ThemeSwitcher'
